import React, { useId } from 'react';
import { motion, type Transition } from 'framer-motion';
import { useTheme } from './ThemeContext';
import { useI18n } from '@/i18n';

const ThemeToggle: React.FC = () => {
  const { theme, toggle } = useTheme();
  const { t } = useI18n();
  const rawId = useId();
  const clipId = `theme-toggle-mask-${rawId.replace(/:/g, '')}`;
  const isDark = theme === 'dark';
  const transition: Transition = { ease: 'easeInOut', duration: 0.35 };
  return (
    <button
      type="button"
      className={`theme-toggle ${theme}`}
      aria-label={theme === 'dark' ? t('theme.switchToLight') : t('theme.switchToDark')}
      aria-pressed={theme === 'dark'}
      onClick={toggle}
    >
      <svg
        className="theme-toggle__icon"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        fill="currentColor"
        strokeLinecap="round"
        viewBox="0 0 32 32"
      >
        <clipPath id={clipId}>
          <motion.path
            className="theme-toggle__mask"
            animate={{ y: isDark ? 14 : 0, x: isDark ? -11 : 0 }}
            transition={transition}
            d="M0-11h25a1 1 0 0017 13v30H0Z"
          />
        </clipPath>
        <g clipPath={`url(#${clipId})`}>
          <motion.circle
            className="theme-toggle__core"
            animate={{ r: isDark ? 10 : 8 }}
            initial={{ r: isDark ? 10 : 8 }}
            transition={transition}
            cx="16"
            cy="16"
            r={isDark ? 10 : 8}
            fill="currentColor"
          />
          <motion.g
            className="theme-toggle__rays"
            animate={{ scale: isDark ? 0.5 : 1, opacity: isDark ? 0 : 1 }}
            transition={transition}
            fill="currentColor"
          >
            <circle cx="16" cy="3.2" r="2.3" />
            <circle cx="16" cy="28.8" r="2.3" />
            <circle cx="28.8" cy="16" r="2.3" />
            <circle cx="3.2" cy="16" r="2.3" />
            <circle cx="6.7" cy="6.7" r="2.3" />
            <circle cx="25.3" cy="25.3" r="2.3" />
            <circle cx="25.3" cy="6.7" r="2.3" />
            <circle cx="6.7" cy="25.3" r="2.3" />
          </motion.g>
        </g>
      </svg>
    </button>
  );
};

export default ThemeToggle;
